import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const DataTransferAgreementRequired = ({ dataTransferAgreementRequired, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div id="dataTransferAgreementRequired" className="planField">
            <GroupApprovers />
            <FormControl>
                <FormLabel className="planRadioTitle" required={required.includes("dataTransferAgreementRequired")}>
                    {xplanLabels.dataTransferAgreementRequired}
                </FormLabel>
                <RadioGroup
                    name="dataTransferAgreementRequired"
                    label={xplanLabels.dataTransferAgreementRequired}
                    value={dataTransferAgreementRequired}
                    onChange={(e) => handleChange("dataTransferAgreementRequired", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"dataTransferAgreementRequired"} /> }
        </div>
    );
};

export default DataTransferAgreementRequired;